import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { first, switchMap } from 'rxjs/operators';
import { RootState } from '../store';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AzureMonitoringService } from '../services/AzureMonitoringService';

@Injectable({ providedIn: 'root' })
export class CustomerIdInterceptor implements HttpInterceptor {
  constructor(@Inject(Store) private store: Store<RootState>, private azureMonitoringService: AzureMonitoringService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.store
      .pipe(
        first(),
        switchMap((state: RootState) => {
          const customerIdAlreadyInHeader = req.headers.get('CustomerId');
          if (!customerIdAlreadyInHeader) {
            let selectedCustomerId = state.session?.selectedCustomer?.data?.id;
            // if superuser (transporter) and no activeCustomer set, take first customer of list of customers assigned
            const isSuperUser = state.session.userContext.isSuperUser;
            if (isSuperUser && !selectedCustomerId) {
              const customers = [...state.session.customerPermissions.data.queryOrGetOrder, ...state.session.customerPermissions.data.queryOrGetFlow];
              selectedCustomerId = customers.length ? customers[0].id : undefined;
            }
            this.azureMonitoringService.customerId = selectedCustomerId; // for logging
            if (selectedCustomerId) {
              req = req.clone({
                setHeaders: {
                  CustomerId: selectedCustomerId,
                },
              });
            }
          }
          return next.handle(req);
        })
      );
  }
}
